import {StateCreator} from 'zustand'
import {TPointAccess} from '../types/project.type'

type State = {
  accesses: (TPointAccess | null)[]
}
type Action = {
  setAccesses: (accesses: (TPointAccess | null)[]) => void
}
export type AccessSlice = State & Action

const createAccessesSlice: StateCreator<AccessSlice> = set => ({
  accesses: [],
  setAccesses: accesses => set({accesses: accesses}),
})

export default createAccessesSlice
